import { Button, Checkbox, Divider, FormControlLabel, Grid, Stack, Typography } from '@mui/material'
import { Box } from '@mui/system'
import React, { useState } from 'react'
import { connect } from 'react-redux'
import { updateAlertError, updateModal } from '../../../../../store/common/common_action'
import DropDownOA from '../../../../common/dropDownOA'
import { navigation3 } from '../../../../common/helper'
import { Item } from '../../../../common/snippets'
import { getApprAuthority, getURRCBRLeftCheckBoxList } from '../../constants'
import { useTranslation } from '../../../../../i18n/I18nProvider'
import InfoIcon from '@mui/icons-material/Info'
import * as sx from '../../../../common/stylesInline/report_daily_branch'
import {  userRRCashBookRightsSave } from '../../../../../store/branchAndUserMaster/BUMAction'
import SuccessfullModal from '../../../../common/SuccessfullModal'
import SuccessAndErrorModal from '../../../../common/SuccessAndErrorModal'
import OTPModal from '../OTPModal'
import { oTPForUserRoleRight } from '../../../../common/jotaiState/commonStateAtoms'


const CashBookRights = (props) => {
    const { translations } = useTranslation()
    const bum = translations?.branchAndUserMaster || {}
    const cs = translations?.common || {}
    const URRCBRLeftCheckBoxList = getURRCBRLeftCheckBoxList(translations)
    const ApprAuthority = getApprAuthority(translations)
    const { data, updateModal,updateAlertError,userRollRightSendOTP,userRRCashBookRightsSave,setCheckValue, showCheckValue, otpOnUserRights,roleId,loginData } = props
    const { common } = data
    const modalStyle = {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
    }

    const [selApprAuth, setSelApprAuth] = useState("")
    const [OtpModal, setOtpModal] = useState(false)
    const [OTP, setOTP] = useState("")
    const [isOpen, setIsOpen] = useState({ open: false, message: "" })
    const [saveError, setSaveError] = useState({ error: false, message: "", })

    const handleChange = (value, field) => {
        setCheckValue({ ...showCheckValue, [field]: value })
    }

    const sendOTPRequest = () => {
        const obj = {
            strOTPType: "UR",
            intCompanyId: loginData?.intCompanyID,
            intRoleID: roleId,
            intSaveType: 1,
            intOTPSendType: selApprAuth?.id
        }
        oTPForUserRoleRight(obj).then((res) => {
            if (res?.Status == true) {
                setOTP(res.OTP)
                setOtpModal(true)
            } else {
                setOTP("")
                updateAlertError({ show: true, msg: res.ErrMessage })
            }
        }).catch((err) => {
            updateAlertError({ show: true, msg: err })
        })
    }

    const saveApi = () => {
        const obj={
            RoleID: roleId,
            AllowCBBankPay: showCheckValue?.AllowCBBankPay,
            AllowCBBankReceive: showCheckValue?.AllowCBBankReceive,
            AllowCBLedgerPay: showCheckValue?.AllowCBLadgerPay,
            AllowCBLedgerReceive: showCheckValue?.AllowCBLadgerReceive,
            AllowCBEntryOwnBranch: showCheckValue?.AllowCBEntryOwnBranch,
            AllowCBEntryAllBranch: showCheckValue?.AllowCBEntryAllBranch,
            AllowCBEntryFranchise: showCheckValue?.AllowCBEntryFranchise,
            AllowCBBankToBank: showCheckValue?.AllowCBBankToBank
          }
        userRRCashBookRightsSave(obj).then((res) => {
            if (res?.status == 'Success') {
                setIsOpen({ ...isOpen, open: true, message: bum.cashBookRightsSavedSuccessfullyNl || "CASH BOOK RIGHTS\nSaved Successfully!" })
            } else {
                setSaveError({ ...saveError, error: true, message: res.Message })
            }
        }).catch((err) => {
            setSaveError({ ...saveError, error: true, message: err })
        })
    }
    const onSave=()=>{
        if (otpOnUserRights == 1) {
            if (selApprAuth === "") {
                updateAlertError({ show: true, msg: bum.selectApprovalAuthority || "Select Approval Authority", nextId: "UmAppAuth" })
            } else {
                sendOTPRequest()
            }
        } else {
            saveApi()
        }
    }
    return (
        <>
            <Box sx={{ padding: "12px", paddingBottom: "0px", marginTop: "16px", marginLeft: "16px", }}>
                <Grid container spacing={2} sx={{ display: "flex", alignItems: "start" }}>
                    {URRCBRLeftCheckBoxList.map((obj, i) =>
                        <Grid item md={obj.md} sx={{ paddingTop: "12px !important" }}>
                            <FormControlLabel
                                key={i}
                                value="end"
                                control={<Checkbox id={obj.id} checked={showCheckValue[obj.field] === 1} sx={{ padding: '0px 5px 0px 5px' }} />}
                                onKeyDown={(e) => {
                                    navigation3(e, obj.nextId, obj.prevId, () => { })
                                }}
                                onChange={(e) => handleChange(e.target.checked ? 1 : 0, obj.field)}
                                label={
                                    <Typography sx={{ fontWeight: '500', fontSize: "14px", color: '#444 !important' }}>
                                        {obj.label}
                                    </Typography>
                                }
                                // onChange={(e) => {
                                //     handleBrnhReportValue(e.target.checked ? 1 : 0, obj.field)
                                // }}
                                labelPlacement="end"
                            />
                        </Grid>
                    )}
                    <Grid item md={7}></Grid>
                </Grid>
                {/* */}
            </Box>
            <Stack className="itemButtons BranchAndUsrBottomSec">
                <Divider />
                <Box className='reportButton' sx={{ display: 'flex', justifyContent: "space-between", padding: "16px", paddingBottom: "0px", gap: "12px" }}>
                    <Box style={{ display: "flex" }}>
                        {
                            otpOnUserRights == 1 ?
                                <>
                                    <Item sx={sx.itemsx} style={{ width: "350px" }} className={'input--wrapper'}>
                                        <DropDownOA
                                            id={"UmAppAuth"}
                                            data={ApprAuthority || []}
                                            defaultvalue={selApprAuth?.name || ''}
                                            width="100%"
                                            searchPlaceholder={bum.searchBranchName || `Search Branch Name`}
                                            label={bum.approvalAuthority || "Approval Authority"}
                                            dataKey={`name`}
                                            idKey={`id`}
                                            nextId={"UMActive"}
                                            field={'compulsory'}
                                            prevId={"UMPAN"}
                                            direction='up'
                                            onSelect={(value) => setSelApprAuth(value)}
                                        />
                                    </Item>
                                    <Box style={{ marginLeft: "5px", display: "flex", alignItems: "center", gap: "5px", fontWeight: "500", fontSize: "13px" }}>
                                        <InfoIcon style={{ color: "#0086FF" }} />
                                        <span style={{ color: "#1E59A7" }}>{bum.otpWillSendToManagementAsPerSelection || "OTP will send to the Management as per Selection"}</span>
                                    </Box>
                                </>
                                : ""
                        }
                    </Box>
                    <Box style={{ display: "flex", gap: "15px" }}>
                        <Item sx={sx.itemsx} className="disabled-wrapper" onKeyDown={(e) => navigation3(e, "UMSave", "UMUserStatus", () => { })}>
                            <Button id={"UMCancel"} variant="outlined" sx={{ width: '100%' }} className="receiveitembtn" onClick={() => updateModal(false, "LuggageRightsUseRollRights")}>
                                {bum.cancel || 'CANCEL'}
                            </Button>
                        </Item>
                        <Item sx={sx.itemsx} className="disabled-wrapper" onKeyDown={(e) => navigation3(e, "UMUserName", "UMCancel", () => { })}>
                            <Button variant="contained" id="UMSave" style={{ ...sx.fullHeight, ...sx.novp, padding: "5px 20px" }} className="btn btn-primary"
                            onClick={() => onSave()}
                            >
                                {bum.save || 'Save'}
                            </Button>
                        </Item>
                    </Box>
                </Box>
            </Stack>
            {OtpModal ? <OTPModal saveApi={saveApi} OTP={OTP} isOpen={isOpen} setIsOpen={setIsOpen} sendOTPRequest={sendOTPRequest} /> : ""}
            <SuccessfullModal modalStyle={modalStyle} handleClose={() => { setIsOpen({ ...isOpen, open: false, message: "" }); updateModal(false, "") }} open={isOpen?.open} title={isOpen?.message} />
            <SuccessAndErrorModal modalStyle={modalStyle} handleClose={() => setSaveError({ ...saveError, error: false })} isError={true} open={saveError.error} title={saveError?.message} />
        </>
    )
}

const mapStateToProps = (data) => ({ data })

const mapDispatchToProps = {
    updateModal,userRRCashBookRightsSave,updateAlertError
}

export default connect(mapStateToProps, mapDispatchToProps)(CashBookRights)